<!-- form title -->
<form class="w-12"
      method="POST"
      #form="ngForm"
      novalidate="true">
    <ng-container *ngIf="model?.data">
        <!-- form body -->
        <ng-container *ngFor="let field of fields; trackBy trackByFieldCid">
            <ng-container [ngSwitch]="field.field_type">
                <input-wrap class="left w-12 m-b-2"
                            [label]="['checkboxes', 'subscription', 'radio', 'file_upload'].indexOf(field.field_type) !== -1 ? field.label : undefined"
                            [required]="!!field.required">

                    <!-- input: text -->
                    <input class="input"
                           type="text"
                           [name]="field.cid"
                           [muiInput]="field.label"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           *ngSwitchCase="'text'">

                    <!-- input: number -->
                    <input class="input"
                           type="number"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [(ngModel)]="data[field.cid]"
                           [muiInput]="field.label"
                           *ngSwitchCase="'number'">

                    <!-- input: email -->
                    <input class="input"
                           type="email"
                           [name]="field.cid"
                           [required]="!!field.required"
                           [muiInput]="field.label"
                           [(ngModel)]="data[field.cid]"
                           *ngSwitchCase="'email'">

                    <!-- input: textarea -->
                    <textarea class="textarea input"
                              [name]="field.cid"
                              [required]="!!field.required"
                              [muiInput]="field.label"
                              [(ngModel)]="data[field.cid]"
                              *ngSwitchCase="'paragraph'"></textarea>

                    <!-- input: select -->
                    <select class="input"
                            [name]="field.cid"
                            [required]="!!field.required"
                            [muiInput]="field.label"
                            [(ngModel)]="data[field.cid]"
                            *ngSwitchCase="'dropdown'">
                        <option *ngFor="let option of field.field_options?.options"
                                [value]="option.label">{{option.label}}</option>
                    </select>

                    <!-- input: checkbox -->
                    <ng-container *ngSwitchCase="'checkboxes'">
                        <checkbox class="w-12 m-t-2"
                                  [name]="field.cid + '[]'"
                                  [checkedValue]="option.label"
                                  [notCheckedValue]="undefined"
                                  [(ngModel)]="data[field.cid][i]"
                                  (ngModelChange)="onCheckboxesChange(field)"
                                  (checkedChange)="detectChanges()"
                                  *ngFor="let option of field.field_options?.options; let i = index; trackBy trackByIndex">
                            <span class="p2"
                                  [innerHtml]="option.label">
                            </span>
                        </checkbox>

                        <ng-container *ngIf="field.required">
                            <input-wrap>
                                <input type="hidden"
                                       [name]="field.cid"
                                       [(ngModel)]="checkboxes[field.cid]"
                                       required>
                            </input-wrap>
                        </ng-container>
                    </ng-container>

                    <!-- input: subscription checkbox -->
                    <ng-container *ngSwitchCase="'subscription'">
                        <checkbox class="w-12 m-t-2"
                                  [name]="field.cid"
                                  [required]="!!field.required"
                                  [(ngModel)]="data[field.cid]">
                            <span class="p2"
                                  [innerHtml]="field.field_options?.options?.[0]?.label">
                            </span>
                        </checkbox>
                    </ng-container>

                    <!-- input: radio -->
                    <ng-container *ngSwitchCase="'radio'">
                        <radio-group class="flex-column"
                                     [name]="field.cid"
                                     [required]="!!field.required"
                                     [(ngModel)]="data[field.cid]">
                            <radio class="w-12 m-t-2"
                                   *ngFor="let option of field.field_options?.options; let i = index; trackBy trackByIndex"
                                   [value]="option.label">
                                <span class="p2"
                                      [innerHtml]="option.label"></span>
                            </radio>
                        </radio-group>
                    </ng-container>

                    <!-- input: file_upload -->
                    <ng-container *ngSwitchCase="'file_upload'">
                        <div [name]="field.cid"
                             [fileUpload]
                             [(file)]="data[field.cid]"
                             (fileChange)="detectChanges()">
                            <ng-template #fileUploadTemplate
                                         let-file>
                                <button class="m-r button"><span>{{ 'Select file' | translate}}</span></button> {{ file
                                ? file.name : 'or drag and drop file here ' }}
                            </ng-template>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'address'">
                        <input-wrap class='w-12 m-b-2'>
                            <input *ngIf="field.show_address"
                                   class="input"
                                   type="text"
                                   [name]="field.cid + '.address'"
                                   [muiInput]="field.label"
                                   [(ngModel)]="data[field.cid].address"
                                   [required]="!!field.required">
                        </input-wrap>
                        <input-wrap class='w-12 m-b-2'>
                            <input *ngIf="field.show_city"
                                   class="input"
                                   type="text"
                                   [name]="field.cid + '.city'"
                                   [muiInput]="'City' | translate"
                                   [(ngModel)]="data[field.cid].city"
                                   [required]="!!field.required">
                        </input-wrap>
                        <input-wrap class='w-12 m-b-2'>
                            <input *ngIf="field.show_country"
                                   class="input"
                                   type="text"
                                   [name]="field.cid + '.country'"
                                   [muiInput]="'Country' | translate"
                                   [(ngModel)]="data[field.cid].country"
                                   [required]="!!field.required">
                        </input-wrap>
                        <input-wrap class='w-12 m-b-2'>
                            <input *ngIf="field.show_state"
                                   class="input"
                                   type="text"
                                   [name]="field.cid + '.state'"
                                   [muiInput]="'State' | translate"
                                   [(ngModel)]="data[field.cid].state"
                                   [required]="!!field.required">
                        </input-wrap>
                        <input-wrap>
                            <input *ngIf="field.show_zipcode"
                                   class="input"
                                   type="text"
                                   [name]="field.cid + '.zipcode'"
                                   [muiInput]="'Zipcode' | translate"
                                   [(ngModel)]="data[field.cid].zipcode"
                                   [required]="!!field.required">
                        </input-wrap>
                    </ng-container>
                </input-wrap>
            </ng-container>
        </ng-container>

        <!-- submit button -->
        <div class="w-12 center">
            <action [status]="status"
                    class="button"
                    (click)="submit()">{{model?.data?.submit_button_text || ('Send' | translate)}}</action>

            <!-- submission result -->
            <result [status]="status"
                    [success]="model?.data?.success_message || ''"
                    class="block m-t-3"></result>
        </div>
    </ng-container>
</form>